module.exports = "<app-menu *ngIf=\"showMenu\"></app-menu>\r\n<router-outlet></router-outlet>\r\n<!-- app-entrenador></app-entrenador -->\r\n"